<!--渠道配置-->
<template>
    <a-card>
        <div>
            <a-form-model  class="search-form" layout="inline" :model="searchForm">
                <a-form-model-item label="名称">
                    <a-input :maxLength="30" allowClear v-model="searchForm.name" placeholder="请输入渠道名称"/>
                </a-form-model-item>
                <a-form-model-item style="margin-right: 35px;">
                    <a-button @click="getPageList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                    <a-button @click="searchReset" style="margin-left: 10px;">
                        重置
                    </a-button>
                </a-form-model-item>
                <a-form-model-item v-permission="`ChannelDispose.Add`" style="float: right;">
                    <a-button @click="modelForm.visible = true" icon="plus" type="primary">添加渠道</a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div style="overflow: auto;">
            <a-table style="min-width: 800px;"
                     :columns="columns"
                     :rowKey="(text, index) => text.id + index"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :dataSource="tableRelevant.tableDataSource">
                <div slot="action" slot-scope="text, record" class="action">
                    <a v-permission="`ChannelDispose.Edit`" @click="edit(text)"
                       href="javaScript:;">
                        <a-icon type="edit"/>
                        编辑</a>
                </div>
            </a-table>
        </div>

        <a-modal :title="modelForm.title"
                 v-model="modelForm.visible"
                 :centered="true"
                 :confirm-loading="modelForm.confirmLoading"
                 @ok="modalOk"
                 @cancel="modalCancel">
            <a-form-model ref="modelForm" :model="modelForm.data"
                    :rules="modelForm.rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 14 }">
                <a-form-model-item label="渠道名称" prop="name">
                    <a-input :maxLength="10" v-model="modelForm.data.name" placeholder="请输入渠道名称"/>
                    <p v-if="modelForm.errorMessage" slot="help" style="color: red;">{{modelForm.errorMessage}}</p>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </a-card>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import $Bus from "@/pages/projectImpl/js/eventBus";

    const columns = [
        {
            title: '渠道名称',
            dataIndex: 'name'
        },
        {
            title: '操作',
            width: 250,
            scopedSlots: {customRender: 'action'}
        }
    ];

    export default {
        name: "ChannelDispose",
        data() {
            return {
                columns,
                searchForm: {
                    name: undefined
                },
                //表格相关
                tableRelevant: tableRelevant.call(this),
                modelForm: {
                    visible: false,
                    confirmLoading: false,
                    title: "添加渠道",
                    errorMessage: "",
                    data: {
                        name: "",
                        id: undefined
                    },
                    rules: {
                        name: { required: true, message: '请输入渠道名称', trigger: 'blur' },
                    }
                }
            }
        },
        mounted() {
            $Bus.$emit("pageHeaderTitle", "渠道列表");
            this.getPageList();
        },
        methods: {
            getPageList(pageIndex) {
                const params = {
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.Channel.getChannelPageList(params).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const {data} = res.data;
                    this.tableRelevant.tableDataSource = data.items;
                    this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
                })
            },

            //重置
            searchReset() {
                this.searchForm = {
                    name: undefined,
                };
                this.getPageList(1);
            },

            edit(val) {
                this.modelForm.title = "编辑渠道";
                this.modelForm.visible = true;
                this.modelForm.data.name = val.name;
                this.modelForm.data.id = val.id;
            },
            modalOk(){
                this.$refs["modelForm"].validate(valid => {
                    if (valid) {
                        let Ajax = this.$http.Channel.addChannel;
                        //const form = new FormData();
                        //form.append("name", this.modelForm.data.name);
                        if (this.modelForm.data .id) {
                            Ajax = this.$http.Channel.updateChannel;
                            //form.append("id", this.modelForm.data.id);
                        }
                        this.modelForm.confirmLoading = true;
                        Ajax(this.modelForm.data).then(res => {
                            this.modelForm.confirmLoading = false;
                            const {message} = res.data;
                            this.$message.success(message);
                            this.modalCancel();
                            this.getPageList(1);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            modalCancel(){
                this.modelForm.title = "添加渠道";
                this.modelForm.data = {
                    name: "",
                    id: undefined
                };
                this.modelForm.errorMessage = "";
                this.$refs["modelForm"].resetFields();
                this.modelForm.visible = false;
            }
        }
    }
</script>

<style scoped>

</style>